__turbopack_context__.v({
  "className": "playfair_display_78daf475-module__OiZxja__className",
});
